import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { LocalStorageService } from 'src/core/services/local-storage.service';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { BatchItem, ScanBatchItem, ScanBatchItemPayload } from 'src/interfaces/batch';
import { OrderItem } from 'src/interfaces/order-item';

interface DialogData {
  title: string;
  message: string;
  batchItems: BatchItem[];
  orderItem: OrderItem;
}

@Component({
  selector: 'core-batch-item-list-dialog',
  templateUrl: './batch-item-list-dialog.component.html',
  styleUrls: ['./batch-item-list-dialog.component.scss']
})
export class BatchItemListDialogComponent implements OnInit {

  scanBatchItems: ScanBatchItem[];

  displayedColumns: string[] = [
    'id',
    'in_stock',
    'scanned',
    'barcode',
    'action'
  ]

  page: number = 1;
  limit: number = 10;
  totalNumberOfBatchItems: number = 0;

  constructor(
    public _dialogRef: MatDialogRef<BatchItemListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: FormBuilder,
    private _prescriptionService: PrescriptionService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {

    this.scanBatchItems = this.data
      .batchItems
      .map(batchItem => ({
        item: batchItem,
        barcodeControl: this._formBuilder.control(batchItem.barcode, Validators.required),
        scanned: batchItem.barcode ? true : false,
        inputId: `barcodeInput${batchItem.id}`,
      }))

    this.totalNumberOfBatchItems = this._prescriptionService.getTotalNumberOfBatchItems();

    const limit = this._localStorageService.get('BATCHITEMS', 'LIMIT');

    if (limit) {
      this.limit = parseInt(limit);
    }

  }

  isInStock(item: BatchItem): boolean {
    return item.in_stock === 1 ? true : false;
  }

  focusItem(item: ScanBatchItem) {
    const input: HTMLInputElement = <HTMLInputElement>document.querySelector(`#${item.inputId}`);
    input.focus();
  }

  onPageChange(event: PageEvent) {
    // Get more orders 
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this._localStorageService.store('BATCHITEMS', 'LIMIT', this.limit.toString());

    (async () => {
      
      if (!this.data.orderItem.id) return;

      const newBatchItems = await this._prescriptionService
        .getBatchItems(this.data.orderItem.id, this.page, this.limit);

      this.scanBatchItems = newBatchItems.map(batchItem => ({
        item: batchItem,
        barcodeControl: this._formBuilder.control(batchItem.barcode, Validators.required),
        scanned: batchItem.barcode ? true : false,
        inputId: `barcodeInput${batchItem.id}`,
      }))
    })();

    this.totalNumberOfBatchItems = this._prescriptionService.getTotalNumberOfBatchItems();
  }



  async submit(item: ScanBatchItem) {

    const payload: ScanBatchItemPayload = {
      barcode: item.barcodeControl.value
    }

    if (!this.data.orderItem.id) return;

    item.scanned = await this._prescriptionService
      .scanBatchItem(this.data.orderItem.id, item.item.id, payload);
  }

  closeDialog() {
    if (this.scanBatchItems.length === 0)
      this._dialogRef.close(false);

    const scannedAllItems: boolean = this.scanBatchItems
      .every(item => item.scanned);

    this._dialogRef
      .close(scannedAllItems);
  }

}
